import {dimColor} from './palette.mjs';
import {COLORS} from './availability.mjs';
// Sixteen color steps keep the sprite cache bounded even for large data.
export function bucket(c) { return c.total && c.out === c.total ? 'out' : !c.known ? 'unknown' : String(Math.round(Math.max(0,Math.min(1,c.available/c.known))*15)); }
export function bubbleColor(b) {
  if (b === 'out') return COLORS.out;
  if (b === 'unknown') return COLORS.neutral;
  const t=Number(b)/15, a=t<=.5?COLORS.red:COLORS.yellow, z=t<=.5?COLORS.yellow:COLORS.green, f=t<=.5?t*2:(t-.5)*2;
  const rgb=s=>s.match(/\w\w/g).map(v=>parseInt(v,16));
  const x=rgb(a.slice(1)),y=rgb(z.slice(1));
  return '#'+x.map((v,i)=>Math.round(v+(y[i]-v)*f).toString(16).padStart(2,'0')).join('');
}
export const PIXEL_RATIO = 2;
export const markerFont = () => 'Inter, system-ui, sans-serif';
export function bubbleStyle(b, theme, profile = {}) {
  const color=bubbleColor(b), dark=theme==='dark';
  return {
    fill: dimColor(b==='out'?'#a7b0bc':color, profile.dimming),
    text: dark?'#f0f4f9':'#17212f',
    border: null,
    shadow: '#0006',
  };
}
